import { useRef } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { IYhForm, IYhFormRef, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { useMealModel } from "../mealModel";
import { IMealDetial } from "../mealTypes";
import moment from 'moment';
import "./meal.less"
import { TimePicker, message } from "antd";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { IMealTypeOptions } from "@/types/AppEnums";
import { getFormValidatorErrText } from "@/utils/utils";
const { RangePicker } = TimePicker
export enum IMealTypeEnum {
    //早餐
    BREAKFAST = "breakfast",
    //中餐
    LUNCH = "lunch",
    //晚餐
    DINNER = "dinner"
}
export function DetailDrawer() {
    const { dataRestaurantSource } = useGlobalModel()
    const {
        visibleDrawer: { visible, mode },
        setIVisibleDrawer,
        addFormVal,
        editFormVal,
        updateAddFormVal,
        updateEditFormVal,
        setMealTypeList,
        orderInCalel, setOrderInCalel,
        setMealTimeList,
        insertDetail,
        editDetail,
        initmealTimeList,
        setAddFormVal,
        setEditFormVal
    } = useMealModel()
    const formRef = useRef<IYhFormRef>();
    const onCancel = () => {
        setIVisibleDrawer()
        setMealTimeList(initmealTimeList)
        setMealTypeList([])
        mode === "edit" ? setEditFormVal({}) : setAddFormVal({})
    }
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            let { orgType, ...params } = val
            mode === "edit" ? editDetail(params) : insertDetail(params)
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    const onChange = (changedValues: { [key: string]: any }) => {
        if ("mealType" in changedValues) {
            setMealTypeList([changedValues.mealType])
        }
        mode == "add" ? updateAddFormVal(changedValues) : updateEditFormVal(changedValues)
    }
    const formConfig: IYhForm<IMealDetial> = {
        formRef,
        labelCol: { span: 6 },
        formValues: mode === "add" ? addFormVal : { ...editFormVal, mealType: editFormVal?.mealType ? editFormVal.mealType.split(",") : [] },
        onChange,
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "餐别名称",
                fieldName: "mealType",
                span: 24,
                options: IMealTypeOptions,
                disable: mode === "edit" ? true : false,
                rules: [{ required: true, message: "请输入餐别名称" }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "餐厅名称",
                fieldName: "canteenId",
                span: 24,
                options: transOptions(dataRestaurantSource),
                disable: mode === "edit" ? true : false,
                rules: [{ required: true, message: "请输入餐厅名称" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "餐别备注",
                fieldName: "note",
                span: 24,
            },
        ]
    }
    return (
        <YHDrawer
            {...{
                title: `餐别管理${mode === 'add' ? '新增' : '编辑'}`,
                visible,
                onCancel,
                width: 700,
                okText: "保存",
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
            <div className="time">
                <div className="time-tabs">
                    <span className="time-tabs-item">时间设置</span>
                </div>
                <div className="time-step">
                    <div className="time-step-item">
                        <div className="title">一、点餐时间</div>
                        <div className="content">
                            {/* defaultValue={[moment('3:00 凌晨'), moment('7:00 晚上')]} */}
                            当日餐当日点，设置当日点餐时间 <RangePicker
                                defaultValue={orderInCalel.startTimeBook && orderInCalel.endTimeBook ? [moment(orderInCalel.startTimeBook, 'HH:mm'), moment(orderInCalel.endTimeBook, 'HH:mm')] : null}
                                format="HH:mm"
                                bordered={false}
                                size="small"
                                style={{ width: 240 }}
                                onChange={(time: any, timeSting: string[]) => {
                                    setOrderInCalel({ ...orderInCalel, startTimeBook: timeSting[0], endTimeBook: timeSting[1] })
                                }} />
                        </div>
                    </div>
                    <div className="time-step-item">
                        <div className="title">二、取消用餐时间</div>
                        <div className="content">
                            每日<TimePicker
                                defaultValue={orderInCalel.cancelMealTime ? moment(orderInCalel.cancelMealTime, 'HH:mm') : undefined}
                                format="HH:mm"
                                bordered={false}
                                size="small"
                                style={{ width: 120 }}
                                onChange={(time: any, timeSting: string) => {
                                    setOrderInCalel({ ...orderInCalel, cancelMealTime: timeSting })
                                }} />之前可以取消当日用餐
                        </div>
                    </div>
                    <div className="time-step-item">
                        <div className="title">三、用餐时间段</div>
                        <div className="content">
                            营业时间<RangePicker
                                format="HH:mm"
                                bordered={false}
                                size="small"
                                style={{ width: 240 }}
                                defaultValue={orderInCalel['startTimeBusiness'] && orderInCalel['endTimeBusiness'] ? [moment(orderInCalel['startTimeBusiness'], 'HH:mm'), moment(orderInCalel['endTimeBusiness'], 'HH:mm')] : null}
                                onChange={(time: any, timeSting: string[]) => {
                                    setOrderInCalel({ ...orderInCalel, startTimeBusiness: timeSting[0], endTimeBusiness: timeSting[1] })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </YHDrawer>
    )
}